import styled, { css } from 'styled-components'

export const VerifiedBadge = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;

  border-radius: 100%;

  width: 18px;
  height: 18px;

  background-color: var(--color-primary);

  color: var(--color-on-primary);
`

export const Badge = styled.div`
  display: grid;

  grid-auto-flow: column;
  gap: 6px;
  align-items: center;

  border: 1px solid;
  border-radius: 100px;
  border-color: color-mix(in srgb, var(--color-on-background) 30%, transparent);

  padding: 4px 10px;

  background-color: color-mix(in srgb, var(--color-on-background) 10%, transparent);

  color: var(--color-on-background);
`

export const Text = styled.div`
  font-size: 14px;
  line-height: 1.5;
`

export const Emoji = styled.div<{ iconOnly?: boolean }>`
  font-weight: normal;
  font-family: 'Segoe UI Emoji';

  ${({ iconOnly }) =>
    iconOnly &&
    css`
      font-size: 20px;
    `}
`

export const Image = styled.img<{ iconOnly?: boolean }>`
  width: 16px;
  height: 16px;
  object-fit: contain;

  ${({ iconOnly }) =>
    iconOnly &&
    css`
      width: 20px;
      height: 20px;
    `}
`
